import React from 'react';
import {
    LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
    ResponsiveContainer, BarChart, Bar
} from 'recharts';

const formatShortDate = (iso) => {
    if (!iso) return '';
    try {
        return new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
    } catch {
        return iso;
    }
};

export const JobsTrendChart = ({ trends = [] }) => {
    const data = (trends || []).map((p) => ({
        date: formatShortDate(p.date),
        created: p.total_services ?? 0,
        completed: p.completed_services ?? 0,
    }));

    return (
        <div className="bg-white rounded-lg border border-gray-200 p-4 md:p-5 shadow-sm h-full">
            <h3 className="text-base md:text-lg font-semibold text-gray-900">Jobs per day</h3>
            <p className="text-xs text-gray-500 mb-4">Last 7 days</p>
            {data.length === 0 ? (
                <div className="h-56 flex items-center justify-center text-sm text-gray-400">No trend data</div>
            ) : (
                <ResponsiveContainer width="100%" height={240}>
                    <LineChart data={data}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                        <XAxis dataKey="date" tick={{ fontSize: 11 }} />
                        <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
                        <Tooltip />
                        <Legend />
                        <Line type="monotone" dataKey="created" stroke="#3B82F6" strokeWidth={2} name="Created" />
                        <Line type="monotone" dataKey="completed" stroke="#10B981" strokeWidth={2} name="Completed" />
                    </LineChart>
                </ResponsiveContainer>
            )}
        </div>
    );
};

export const JobsByLocationChart = ({ rows = [] }) => {
    const data = (rows || []).slice(0, 8).map((r) => ({
        name: (r.location_name || `Loc ${r.location_id}`).slice(0, 18),
        completed: r.completed_mtd ?? 0,
        created: r.created_mtd ?? 0,
    }));

    return (
        <div className="bg-white rounded-lg border border-gray-200 p-4 md:p-5 shadow-sm h-full">
            <h3 className="text-base md:text-lg font-semibold text-gray-900">Jobs by location</h3>
            <p className="text-xs text-gray-500 mb-4">This month</p>
            {data.length === 0 ? (
                <div className="h-56 flex items-center justify-center text-sm text-gray-400">No location data</div>
            ) : (
                <ResponsiveContainer width="100%" height={240}>
                    <BarChart data={data} margin={{ left: 0, right: 8 }}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                        <XAxis dataKey="name" tick={{ fontSize: 10 }} interval={0} angle={-20} textAnchor="end" height={60} />
                        <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey="created" fill="#93C5FD" name="Created" radius={[4, 4, 0, 0]} />
                        <Bar dataKey="completed" fill="#34D399" name="Completed" radius={[4, 4, 0, 0]} />
                    </BarChart>
                </ResponsiveContainer>
            )}
        </div>
    );
};
